import { render, staticRenderFns } from "./DriverListMenuForm.vue?vue&type=template&id=48279519"
import script from "./DriverListMenuForm.vue?vue&type=script&lang=js"
export * from "./DriverListMenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports